/* eslint-disable */
import styles from './index.module.scss'
import logo from '../../../assets/images/whiteLogo.svg'
import darkLogo from '../../../assets/images/logo.svg'
import text from './text.json'
import { Link } from 'react-router-dom'
import { useEffect, useState, useContext } from 'react'
import {
  CopyRight,
  fbIcon,
  liIcon,
  ytIcon,
  InstaIcon,
  CallCentre,
  Wp,
} from '../../../icons'
import { PageContext } from '../../../context/PageContextProvider'
import ContactAPI from '../../../api/contact'
import Loading from '../../pages/loading'

const Footer = ({ className }) => {
  const { language, theme } = useContext(PageContext)
  const [contact, setContact] = useState([])
  const [load, setLoad] = useState(false)
  const links = [
    { img: fbIcon, path: contact?.facebook_link },
    { img: liIcon, path: contact?.linkedin_link },
    { img: ytIcon, path: contact?.youtube_link },
    { img: InstaIcon, path: contact?.instagram_link },
    { img: Wp, path: contact?.whatsapp_link },
  ]
  useEffect(() => {
    (async () => {

    const data1 = await ContactAPI.getAll()
    await setContact(data1.data)
    await setLoad(true)
  
    })();
  }, [])

  return load ? (
    <footer className={`${className} ${styles.footer}`}>
      <div>
        <div className={styles.brand_col}>
          <img src={theme === 'dark' ? logo : darkLogo} alt={'BPG'} className={styles.footer_logo} />
          <div className={styles.contact_box}>
            <h3>{text.contact?.[language] || text.contact?.AZ}</h3>
            <span className={styles.call}>
              <CallCentre />
              <a href={`tel:${contact?.callCentre || (contact?.phone && contact?.phone[0]) || '+994554248126'}`}>
                {' '}{contact?.callCentre || (contact?.phone && contact?.phone[0]) || '+994 55 424 81 26'}
              </a>
            </span>
            {(contact?.email && Array.isArray(contact.email) && contact.email.length > 0) ? (
              contact.email.map((item, idx) => (
                <a key={idx} href={`mailto:${item}`}>{item}</a>
              ))
            ) : (
              <a href="mailto:qmirismayil@gmail.com">qmirismayil@gmail.com</a>
            )}
          </div>
        </div>

        <div className={styles.menu_col}>
          <h3>{text.menu?.[language] || text.menu?.AZ}</h3>
          {text.links.map((item, i) => (
            <Link key={i} to={item.path}>
              {item[language] || item.AZ}
            </Link>
          ))}
        </div>

        <div className={styles.terms_col}>
          <h3>{text.term?.[language] || text.term?.AZ}</h3>
          {text.terms.map((item, i) => (
            <Link key={i} to={item.path}>
              {item[language] || item.AZ}
            </Link>
          ))}
        </div>
      </div>

      <div>
        <div>
          <div>
            <CopyRight /> 2025 BPG Consulting Centre
          </div>
          <div className={styles.social_wrapper}>
            <span>{text.follow?.[language] || text.follow?.AZ}</span>
            <div className={styles.social_links}>
              {links.map((item, idx) => (
                <a key={idx} href={item.path} target="_blank" rel="noreferrer" className={styles.social_icon}>
                  <item.img />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  ) : (
    <Loading />
  )
}

export default Footer
